import React                  from 'react';
import { BrandMarkOptions }   from '@tokamap/core';
import ProjectModel           from '@models/map/ProjectModel';
import { functionalityStore } from '@/components/Functionality';
import imageOf                from '@/components/imageOf';
import useFileImageSrc        from '@/components/useFileImageSrc';
import fileStore              from '@/stores/fileStore';
import getSitePublicUrl       from '@/helpers/getSitePublicUrl';

export const BRANDING_LOGO_REFERENCE = 'project_branding_copyright_logo';

const HAS_SCHEME = /^[a-z][a-z\d+.-]*:/i;

export function toBrandingLink(input: string): string | undefined {
	const value = input.trim();

	if (!value) return undefined;

	try {
		const url = new URL(HAS_SCHEME.test(value) ? value : `https://${value}`);

		if (url.protocol !== 'http:' && url.protocol !== 'https:') return undefined;
		if (!url.hostname.includes('.')) return undefined;

		return url.href;
	} catch {
		return undefined;
	}
}

/** `undefined` tant que l'offre ou le logo du projet ne sont pas connus. */
export function useProjectBrandMark(project: ProjectModel): BrandMarkOptions | undefined {
	const isCustomizable = functionalityStore.isEnabled('white_label');
	const logo = isCustomizable ? imageOf(project, BRANDING_LOGO_REFERENCE) : undefined;
	const logoSrc = useFileImageSrc(logo, `Logo de marque du projet ${project.id}`);
	const areFilesLoaded = !!fileStore.itemDictionary[project.urn]?.loaded;

	React.useEffect(() => {
		functionalityStore.whenEnabled('white_label');
	}, []);

	if (isCustomizable === undefined) return undefined;

	if (isCustomizable) {
		if (!areFilesLoaded || (logo && !logoSrc)) return undefined;

		const text = project.brandingText?.trim() || undefined;

		if (logoSrc || text) {
			return { image: logoSrc, text, href: toBrandingLink(project.brandingUrl || ''), label: project.title };
		}
	}

	return { image: '/logo.svg', href: getSitePublicUrl(), label: 'Tokamap' };
}
